//
//
//
//
//
//

import {mapGetters} from "vuex";
export default {
  name: "SectionMunicipalityGuidesGrid",
  components: {
    GuidesGrid: () => import("@/components/common/GuidesGrid")
  },
  computed: {
    ...mapGetters({
      municipality_id: 'municipality/id'
    }),
    guidesGridParams() {
      return {
        city_id: this.municipality_id,
        count: 8,
        page: 1,
      }
    },
  }
};
